module.exports = __webpack_public_path__ + "static/media/catering-white.f4a735b2.svg";